import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Spinner.module.scss'

/**
 * Чистый спиннер.
 *   <Spinner />              // 32px, accent
 *   <Spinner size={48} />
 *   <Spinner color="#fff" /> // в кнопке
 *   <Spinner.Center />       // полностью центрированный для страницы
 */
const Spinner = ({ size = 32, color = 'var(--color-accent, #ff8c00)', strokeWidth = 3, label }) => {
  const { t } = useTranslation('common')
  const resolvedLabel = label ?? t('auto.unvui_spinner.loading', 'Загрузка')
  return (
    <span
      className={styles.spinner}
      role="status"
      aria-label={resolvedLabel}
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 50 50"
        width={size}
        height={size}
        aria-hidden="true"
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          className={styles.path}
        />
      </svg>
    </span>
  )
}

const SpinnerCenter = ({ label }) => (
  <div className={styles.centerWrap}>
    <Spinner label={label} />
  </div>
)

Spinner.Center = SpinnerCenter

export default Spinner
